import { UserDto } from "./user.dto";

export class ProductionTimeDto {
    id!: number;
    startDate!: Date;
    endDate!: Date;
    productionOrderProcessId!: number;
    finishedBy?:UserDto;
}
